import React from "react";
import { Button, Image, Modal } from "react-bootstrap";
import Delete from "../../assets/DeleteIcon.svg";
import { Link } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";

const DeletePopUp = ({ onHide, DeleteFuc, CityID, btnloading, ...props }) => {
  const DeleteHandler = () => {
    const data = {
      user_id: parseInt(CityID),
    };
    DeleteFuc(data);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="popup-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="text-center mb-5">
        <Image loading="lazy" src={Delete} className="errorIconImage" />
        <p className="py-3 delete-text">
          Are you sure you want to delete your business account?
          <br />
          <br />
          {
            props.deleted_account_status === true ? "If you delete your business account you will not have access to any information about your customers. Please confirm if you want to delete you account." : props.deleted_account_status === false ? "Unfortunately you have an outstanding voucher that has not been redeemed by your customer. You cannot delete your account until the voucher has been redeemed. Please contact us at support@communityx.digital for options to consider." : "Once you confirm, our team will review your request and get back toyou within 48 hours with the options."
          }

        </p>
        <div className="text-center small-btns d-flex">
          {
            props.deleted_account_status === false ?
              <Link onClick={onHide}>
                <p className="view">Cancel</p>
              </Link> : <>
                <Link onClick={onHide}>
                  <p className="view">No</p>
                </Link>
                <Button
                  onClick={DeleteHandler}
                  variant="primary"
                  className="green-btn mt-3"
                >
                  {btnloading === true ? (
                    <RotatingLines strokeColor="white" width={20} visible={true} />
                  ) : (
                    "Yes"
                  )}
                </Button>
              </>
          }

        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeletePopUp;
